import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import AgentLayoutIndex from '../_layouts/index'

declare var window: interfaces.IWindow

interface IProps {
  agent_members: {
    agent_members: IJsonResponse
  }
  agent_roles: any
  user: any
}

const COLUMNS = [
  { name: I18n.t('generic.name'), field: 'name', required: true },
  { name: I18n.t('generic.email'), field: 'email', required: true },
  { name: I18n.t('generic.agent_roles'), field: 'agent_role_name', required: false },
  { name: I18n.t('generic.status'), field: 'status_label', required: false },
]

const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'disabled', label: 'Disabled' },
]

const AgentMembersIndex: React.FC<IProps> = props => {
  const { data, pagination } = agentService.getDataFromJson(props.agent_members.agent_members)
  const [agentMembers, setAgentMembers] = React.useState(data)
  const [statusFilter, setStatusFilter] = React.useState('all')

  const filteredUsers = React.useMemo(() => {
    if (statusFilter === 'all') {
      return agentMembers
    }
    return agentMembers.filter(
      u => u.status_label === (statusFilter === 'active' ? 'Active' : 'Disabled')
    )
  }, [agentMembers, statusFilter])

  const handleDelete = React.useCallback(
    async id => {
      try {
        const response = await agentService.deleteAgentMember(id)
        window.flashMessages.addMessage({
          text: response.data.flush.message,
          type: response.data.flush.type,
        })
        setAgentMembers(agentMembers.filter(u => u.id !== id))
      } catch (e) {
        if (e.response?.data?.errors) {
          window.flashMessages.addMessage({
            text: e.response.data.errors,
            type: 'error',
          })
        }
      }
    },
    [agentMembers]
  )

  return (
    <AgentLayoutIndex
      model="agent_members"
      title={
        <Heading>
          <span>{I18n.t('generic.agent_members')}</span>
          <Button small={true}>
            <a href="/agent/agent_members/new">{I18n.t('generic.create_new')}</a>
          </Button>
        </Heading>
      }
      main={
        <>
          <StatusFilter>
            {STATUS_OPTIONS.map(opt => (
              <FilterButton
                key={opt.value}
                active={statusFilter === opt.value}
                onClick={() => setStatusFilter(opt.value)}
              >
                {opt.label}
              </FilterButton>
            ))}
          </StatusFilter>
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={filteredUsers}
            pagination={pagination}
            handleDelete={handleDelete}
            getEditLink={({ id }) => `/agent/agent_members/${id}/edit`}
          />
        </>
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

const StatusFilter = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`

const FilterButton = styled.button<{ active: boolean }>`
  padding: 6px 16px;
  border: 1px solid ${p => (p.active ? constants.COLORS.primary : '#ccc')};
  border-radius: 20px;
  background: ${p => (p.active ? constants.COLORS.primary : '#fff')};
  color: ${p => (p.active ? '#fff' : '#333')};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    opacity: 0.8;
  }
`

export default AgentMembersIndex
